<template>
  <div
    v-if="modalIsOpen"
    class="modal-overlay"
    :class="{ contentTop, contentBottom, contentCenter }"
    allowfullscreen
  >
    <i
      class="fa fa-times close-button"
      :class="{ 'text-white': whiteCloseBtn }"
      @click="handleCloseClick"
      v-if="dismissable"
      id="dismiss-modal"
    ></i>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRef } from "vue";

export default defineComponent({
  props: {
    isOpen: {
      type: Boolean,
      default: null,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
    verticalAlignment: {
      type: String,
      default: "top",
    },
    whiteCloseBtn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onClose"],
  setup(props) {
    return {
      modalIsOpen: toRef(props, "isOpen"),
      contentCenter: props.verticalAlignment === "center",
      contentTop: props.verticalAlignment === "top",
      contentBottom: props.verticalAlignment === "bottom",
    };
  },
  methods: {
    handleCloseClick(e: MouseEvent): void {
      this.$emit("onClose", e);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $pj-color-white;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  z-index: 9999;

  &.contentCenter {
    align-items: center;
  }
  &.contentTop {
    align-items: flex-start;
    padding-top: 70px;
  }
  &.contentBottom {
    align-items: flex-end;
  }
}
.close-button {
  color: $pj-color-black;
  font-size: 25px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px 15px;
  z-index: 10000;
}
</style>
